// extracted by mini-css-extract-plugin
export default {"container":"gameLayout_container__vrguP","topContent":"gameLayout_topContent__FD-xP"};